module.exports = __webpack_public_path__ + "static/media/profile-hand-top.e323864f.svg";